import superagent from 'superagent';
import webservice from './webservice';
import getCookie from './getCookie';

export default async function getPremios() {
  const url = `${webservice}/getPremios?Kit=${getCookie('usuarioOk')}`;
  let response = {};

  await superagent
    .get(url)
    .auth(getCookie('TMBcartToken'), { type: 'bearer' })
    .then((res) => {
      response = res?.body || {};
    })
    .catch((err) => {
      console.log(err);
      const resp = {
        error: err,
        tipoMensaje: 'error',
        mensaje: 'Error',
      };
      response = resp;
    });

  return response;
}
